import { OperationStatus } from '../../entities/operationStatus'
import { StandOperationResult } from '../../entities/standOperationResult'
import { AesStandData } from './aesStandData'

export class AesOperationResultAdapter {
  convert(data: AesStandData): StandOperationResult {
    return {
      outcome: mapOutcome(data),
      area1TagId: data.firstReaderTagId,
      area2TagId: data.secondReaderTagId,
      selectedTagId: data.selectedTagId,
      switchStatus: data.switchStatus,
      isIntermediateRead: data.isPreClosed,
      firmwareVersion: data.firmwareVersion,
      telemetry: null,
      rawResponseHex: data.rawData,
    }
  }
}

function mapOutcome(data: AesStandData): OperationStatus {
  switch (data.standResult) {
    case 'success':
      return 'fullyRead'
    case 'readFirstReaderOnly':
      return 'partialReadArea1'
    case 'readSecondReaderOnly':
      return 'partialReadArea2'
    case 'preClosedReadFirstReaderOnly':
      return 'switchAcceptedWithArea1'
    case 'preClosedReadBothReaderFailed':
      return 'switchAcceptedNoReads'
    case 'timeouted':
      return 'failed'
    case 'irregular':
      return 'irregular'
  }
}
